import api from './api';
import {
  ApiResponse,
  CommonParams,
  CompanyDto,
  CompanyParams,
  GetCompanyParams,
  GetStoresResp,
  GetUsersResp,
} from "@/types";
import { createQueryString } from "@/utils/filterParams";

export const companyService = {
  // Create company
  createCompany: async (
    companyData: CompanyParams
  ): Promise<ApiResponse<CompanyDto>> => {
    try {
      const response = await api.post('/company', companyData);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },

  getCompanies: async (
    params?: GetCompanyParams
  ): Promise<ApiResponse<CompanyDto[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 1,
        limit: 14,
        orderBy: 'id',
        order: 'DESC',
        withDeleted: 0,
        ...params,
      };

      const paramsString = createQueryString(paramsValue);
      const response = await api.get(`/company?${paramsString}`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.message || '');
    }
  },

  getCompanyById: async (id: number): Promise<ApiResponse<CompanyDto>> => {
    try {
      const response = await api.get(`/company/${id}`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.message || '');
    }
  },

   getMyCompany: async (): Promise<ApiResponse<CompanyDto>> => {
    try {
      const response = await api.get(`/company/my-company`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.message || '');
    }
  },

  updateCompany: async (
    id: number,
    companyData: CompanyParams
  ): Promise<ApiResponse<CompanyDto>> => {
    try {
      const response = await api.patch(`/company/${id}`, companyData);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },

  updateCompanyStatus: async (
    id: number,
    status: 'ENABLE' | 'DISABLE'
  ): Promise<ApiResponse<null>> => {
    try {
      const response = await api.patch(`/company/${id}/status`, { status });
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },
  updateCompanyTypeToNonMember: async (
    id: number,
  ): Promise<ApiResponse<null>> => {
    try {
      const response = await api.patch(`/company/${id}/type`);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },
  deleteCompany: async (id: number): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/company/${id}/soft-delete`);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },
  getStores: async (
    companyId: number,
    params?: CommonParams<{}>
  ): Promise<ApiResponse<GetStoresResp[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 1,
        limit: 8,
        orderBy: "id",
        order: "DESC",
        withDeleted: 0,
        ...params,
      };

      const paramsString = createQueryString(paramsValue);
      const response = await api.get(`/company/${companyId}/stores?${paramsString}`);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },
  getMyStores: async (
    params?: CommonParams<{}>
  ): Promise<ApiResponse<GetStoresResp[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 1,
        limit: 8,
        orderBy: "id",
        order: "DESC",
        withDeleted: 0,
        ...params,
      };

      const paramsString = createQueryString(paramsValue);
      const response = await api.get(`/company/my-store?${paramsString}`);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },
  getUsers: async (
    companyId: number,
    params?: CommonParams<{}>
  ): Promise<ApiResponse<GetUsersResp[]>> => {
    try {
      const paramsValue = {
        page: 1,
        isPagination: 1,
        limit: 20,
        orderBy: "id",
        order: "DESC",
        withDeleted: 0,
        ...params,
      };

      const paramsString = createQueryString(paramsValue);
      const response = await api.get(`/company/${companyId}/users?${paramsString}`);
      return response.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  },
};
